import React, { useState } from "react";
import { IconButton, makeStyles, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles((theme) => ({
    cardMenu: {
        float: 'right',
        zIndex: 1
    },
}));

const ITEM_HEIGHT = 48;

const ContextualMenu = ({ elements }) => {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const onClickElement = (action) => {
        handleMenuClose();
        action();
    }

    return (
        <>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
                className={classes.cardMenu}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={openMenu}
                onClose={handleMenuClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
                {elements.filter(e => e.show !== false).map(element => (

                    <MenuItem key={element.key} onClick={() => onClickElement(element.action)}>
                        {element.title}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default ContextualMenu;